import React from 'react';
import { brandStrip } from '../mock';
import { Facebook, Linkedin, Twitter, Instagram, ArrowRight } from 'lucide-react';

const LOGO_URL =
  'https://customer-assets-jt897jd0.emergentagent.net/job_jh-intl-recruitment/artifacts/g0jgfmtg_logo.png';

export default function Footer() {
  return (
    <>
      {/* Marquee strip */}
      <div className="jh-dark border-t border-white/5 overflow-hidden py-8">
        <div className="flex whitespace-nowrap jh-marquee gap-16">
          {[...brandStrip, ...brandStrip, ...brandStrip].map((b, i) => (
            <div
              key={i}
              className="font-display font-extrabold text-white/25 text-[36px] md:text-[44px] tracking-tight"
            >
              • {b}
            </div>
          ))}
        </div>
      </div>

      {/* CTA band */}
      <div className="jh-dark">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 grid md:grid-cols-2 gap-8 items-center border-t border-white/5">
          <div>
            <span className="jh-eyebrow" style={{ color: '#fff' }}>
              Ready to hire compliant, work-ready Ghanaian talent?
            </span>
            <h3 className="jh-h2 text-white mt-4">
              Partner with John Herbert Limited
            </h3>
          </div>
          <div className="md:justify-self-end">
            <a href="#contact" className="jh-btn-primary">
              Start a Conversation <ArrowRight size={18} />
            </a>
          </div>
        </div>
      </div>

      {/* Main footer */}
      <footer className="jh-dark text-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-4 gap-10 border-t border-white/10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <img
                src={LOGO_URL}
                alt="John Herbert Limited"
                className="h-10 w-auto object-contain"
                draggable={false}
              />
            </div>
            <p className="text-white/60 leading-relaxed max-w-md">
              Government of Ghana-licensed Private Employment Agency
              (PEA/819). Ethical, transparent international recruitment of
              Ghanaian professionals and skilled workers.
            </p>
            <div className="flex items-center gap-3 mt-6">
              {[Facebook, Linkedin, Twitter, Instagram].map((I, i) => (
                <a
                  key={i}
                  href="#"
                  aria-label="social"
                  className="w-10 h-10 rounded-full bg-white/5 hover:bg-[#E11D2E] flex items-center justify-center transition-colors"
                >
                  <I size={16} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <div className="text-white font-semibold mb-4">Explore</div>
            <ul className="space-y-3 text-white/60">
              {['About', 'Services', 'Industries', 'Why Ghana', 'Licences', 'Contact'].map((l) => (
                <li key={l}>
                  <a
                    href={`#${l.toLowerCase().replace(' ', '-')}`}
                    className="hover:text-white transition-colors"
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-white font-semibold mb-4">Get in touch</div>
            <ul className="space-y-3 text-white/60 text-[14.5px]">
              <li>1B Sixth Circular Road,<br />Cantonments<br />Accra, Ghana</li>
              <li>
                <a href="mailto:hello@johnherbertltd.com" className="hover:text-white">
                  hello@johnherbertltd.com
                </a>
              </li>
              <li className="text-white/40">Licence: PEA/819</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10">
          <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between text-white/40 text-[13px] gap-3">
            <span>© {new Date().getFullYear()} John Herbert Limited. All rights reserved.</span>
            <span>Licensed under the Labour Act, 2003 (Act 651) — Government of Ghana.</span>
          </div>
        </div>
      </footer>
    </>
  );
}
